/* ReportingLines.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./ReportingLines.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  reportingLinesSection: "_18u01b66 _19pku2gc",
  managerSection: "_1e0c1txw _4cvr1h6o _18u01b66 _19pk1b66 _otyr1b66 _2hwx1b66",
  managerName: "_11c81o8v _18u0u2gc",
  offsetWrapper: "_19pk1b66 _18u0r5cr"
};
export var ReportingLinesSection = function ReportingLinesSection(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.reportingLinesSection)
  }, children);
};
export var ManagerSection = function ManagerSection(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.managerSection)
  }, children);
};
export var ManagerName = function ManagerName(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.managerName)
  }, children);
};
export var OffsetWrapper = function OffsetWrapper(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.offsetWrapper)
  }, children);
};